import { IComponentOptions, IController } from 'angular';
import './info-modal.component.scss';

export interface IInfoModalData {
  text?: string;
  textArray?: string[];
  noTextCentered?: boolean;
  example?: {
    message1?: string;
    message2?: string;
  };
  title?: string;
  buttonText?: string;
}

export class InfoModalController implements IController {
  data: IInfoModalData = {};
  onClose: ( data: { result: boolean, delay?: number } ) => void;
  defaultTitle = 'Info';

  closeModal() {
    this.onClose({ result: null });
  }
}

export const InfoModalComponent: IComponentOptions = {
  controller: InfoModalController,
  template: require('./info-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/info-modal/info-modal.component.ts